<template>
  <div>
    <div
      v-show="isVisible"
      class="relative z-1 -mt-12 hidden break-words rounded-3xl bg-blue-700 pt-12 text-white sm:-mt-13 sm:rounded-4xl lg:block"
    >
      <div
        role="presentation"
        class="pointer-events-none absolute inset-0 -z-1 rounded-inherit bg-gradient-to-l from-blue-300/50 via-blue-300/50 via-20% to-blue-700/0 to-[123%]"
      />
      <div
        class="container mx-auto grid items-center gap-10 py-1.5 lg:grid-cols-2"
      >
        <div
          class="flex items-center gap-3.5 text-sm leading-4 sm:-mx-3 sm:gap-5 sm:text-lg sm:leading-6 lg:mr-0"
        >
          <img
            :src="discountTagUrl"
            loading="lazy"
            :alt="t('new-customers-discount.5percent-tag-img')"
            class="h-12 w-12 shrink-0 sm:h-14 sm:w-16 lg:h-16"
          />
          <IntlMsg
            v-bind="{ k: 'new-customers-discount.description-header' }"
            class="text-pretty"
          />
        </div>
        <form
          novalidate
          class="hidden items-center justify-end gap-6 lg:flex"
          @submit.prevent="handleSubmit(true)"
        >
          <TextEditor
            v-model="email"
            v-bind="{
              id: 'new-customer-discount-email',
              type: 'email',
              inputmode: 'email',
              autocomplete: 'email',
              placeholder: t('label.email'),
            }"
            class="w-full max-w-xs text-gray-800"
          >
            <template v-if="status === 'error'" #error>
              <span></span>
            </template>
          </TextEditor>

          <AwaitButton
            v-bind="{ loading: status === 'loading', variant: 'white' }"
            type="submit"
            class="c-btn--sm max-w-1/2 shrink-0 ring-offset-2 ring-offset-blue-500 focus-visible:ring-white"
          >
            <IntlMsg
              class="truncate"
              v-bind="{
                k: 'new-customers-discount.get-discount',
              }"
            />
          </AwaitButton>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { IntlMsg } from '/@shared/app'
import { AwaitButton, usePromo } from '/@app'
import { TextEditor } from '/@shared/form'

import discountTagUrl from '/@/assets/images/discount-tag-5-percent.svg'

import { useI18n } from '/@/i18n'

const { t } = useI18n()

const { email, handleSubmit, isVisible, status } = usePromo()
</script>
